import { Card } from '@mantine/core';
import { type ReactElement } from 'react';

interface Props {
  children: ReactElement | ReactElement[];
}

export const StyledCard = (props: Props): ReactElement => {
  const { children } = props;
  return (
    <Card padding="md" radius="md" withBorder>
      {children}
    </Card>
  );
};
